import { createAsyncThunk } from '@reduxjs/toolkit';

import type { Comarca, ComarcaFilters } from '@/types/comarca/comarcaTypes';

import { comarcaService } from './services';

export const listarComarcas = createAsyncThunk(
  'comarca/listar',
  async (filters?: ComarcaFilters) => {
    return await comarcaService.listar(filters);
  },
);

export const buscarComarcasPorTribunal = createAsyncThunk(
  'comarca/buscarPorTribunal',
  async (tribunalId: string) => {
    return await comarcaService.buscarPorTribunal(tribunalId);
  },
);

export const buscarComarca = createAsyncThunk(
  'comarca/buscar',
  async (id: string): Promise<Comarca> => {
    return await comarcaService.buscar(id);
  },
);
